import React from 'react';
import {Link} from 'react-router-dom';
import {Trash2Icon} from 'lucide-react';
import {SavedTranslationRow} from '../../api/assistant/savedTranslations.ts';
import {Label, StatusChip} from '../ds/Badge.tsx';
import Icon from '../shared/Icon.tsx';
import {modeLabel, pageLinkFor, savedAgo} from './savedTranslationFormat.ts';

interface SavedTranslationsListProps {
    rows: SavedTranslationRow[];
    onOpen: (row: SavedTranslationRow) => void;
    onDelete: (row: SavedTranslationRow) => void;
    // The list of everything also says where each one is from.
    showPage?: boolean;
}

const SavedTranslationsList: React.FC<SavedTranslationsListProps> = ({
    rows,
    onOpen,
    onDelete,
    showPage
}) => (
    <ul className="mx-saved-translations">
        {rows.map(row => {
            const link = showPage ? pageLinkFor(row) : null;
            return (
                <li key={row.id} className="mx-saved-translation">
                    <button
                        type="button"
                        className="btn btn-link mx-saved-translation-open"
                        onClick={() => onOpen(row)}
                    >
                        <span className="fw-semibold">{row.language}</span>
                        <Label>{modeLabel(row.mode)}</Label>
                        <span className="small text-muted">
                            {savedAgo(row.createdOnUtc)}
                        </span>
                        {row.outOfDate && (
                            <StatusChip status="warning">
                                Out of date
                            </StatusChip>
                        )}
                    </button>
                    {showPage &&
                        (link ? (
                            <Link to={link} className="small text-truncate">
                                {row.title}
                            </Link>
                        ) : (
                            <span className="small text-muted text-truncate">
                                {row.title}
                            </span>
                        ))}
                    <button
                        type="button"
                        className="btn btn-tertiary btn-sm btn-icon-only"
                        aria-label={`Delete the saved ${
                            row.language
                        } ${modeLabel(row.mode).toLowerCase()}`}
                        title="Delete"
                        onClick={() => onDelete(row)}
                    >
                        <Icon icon={Trash2Icon} size="xs" />
                    </button>
                </li>
            );
        })}
    </ul>
);

export default SavedTranslationsList;
